import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { configureStore } from "@reduxjs/toolkit";
import { MyProvider } from "./hooks/MyContaxtApi";
import rootReducer from "./slices";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const store = configureStore({ reducer: rootReducer, devTools: true });
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <MyProvider>
        <BrowserRouter
          basename={process.env.PUBLIC_URL}
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <App />
        </BrowserRouter>
      </MyProvider>
    </Provider>
  </React.StrictMode>
);

// گزارش عملکرد اپلیکیشن
reportWebVitals();

// 📌 ثبت Service Worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .then((registration) => {
        console.log("service worker is ok for App ✅");
      })
      .catch((error) => {
        console.error("❌ Service Worker registration failed:", error);
      });
  });
}

// 📌 رویداد beforeinstallprompt
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();

  // می‌توانید این رویداد را ذخیره کنید و دکمه نصب سفارشی ایجاد کنید
});
